module.exports = __webpack_public_path__ + "media/images/flags/32/Saint-Kitts-and-Nevis-6b9371964ae58d9cb8ef1fe6fefc9765.png";